import { useParams } from "react-router-dom";
import "../../styles/agency-lookup.css";
import React, { useEffect, useState } from "react";
import { getAgencies } from "./service";
import DisplayTemplate from "./display-template";

const Page = () => {
  const [agencies, setAgencies] = useState(undefined);
  const [isLoaded, setIsLoaded] = useState(true);
  const { token } = useParams();

  useEffect(() => {
    setIsLoaded(true);

    document.title = "Piedmont Natural Gas";

    const iconHref = "https://www.piedmontng.com/dist/jsspublic/favicon-png.ico";
    const pngtabIconHref =
      "https://www.piedmontng.com/dist/jsspublic/apple-touch-icon.png";
    const iconLink = document.querySelector('link[rel="icon"]');
    const appleIconLink = document.querySelector('link[rel="apple-touch-icon"]');
    const prevIconHref = iconLink?.getAttribute("href");
    const prevAppleIconHref = appleIconLink?.getAttribute("href");

    if (iconLink) iconLink.setAttribute("href", iconHref);
    if (appleIconLink) appleIconLink.setAttribute("href", pngtabIconHref);
    
    getAgencies(token).then(agenciesRes => {
      if(agenciesRes && agenciesRes.packet && agenciesRes.packet.length) {
        setAgencies(agenciesRes);
      }
    }).finally(() => {
      setIsLoaded(false);
    });

    return () => {
      if (iconLink && prevIconHref) iconLink.setAttribute("href", prevIconHref);
      if (appleIconLink && prevAppleIconHref) {
        appleIconLink.setAttribute("href", prevAppleIconHref);
      }
    };
  }, [token]);
  
  return(<div style={{ display: "flex", height: "100%", width: "100%"}}>
    {isLoaded ? 
      <div>Loading...</div> : 
      (agencies ? 
        <DisplayTemplate agencies={agencies} token={token}/> : 
        <div style={{
          margin: "auto",
          width: "50%",
          minWidth: 350,
          padding: 10,}}>
          <img style={{margin: "auto", height: 70, }} src="https://emails.duke-energy.com/brand/logos/logo-png.png" alt="No agencies found" />
          <p style={{
            margin: "auto", 
            textAlign: "center", 
            marginTop: 10,
            fontFamily: "Arial,sans-serif", }}>
            We are sorry, but the link has expired. To find more information about special assistance programs and resources, visit <a target="_blank" rel="noreferrer" href="https://nam13.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.piedmontng.com%2Four-company%2Fabout-piedmont%2Four-community%2Fenergy-assistance-programs&data=05%7C02%7Cmeghan.shaw%40messagebroadcast.com%7C6a24971665bd4475aa3a08de8c337a3e%7Cb561233fcff54727af7f4037e2439961%7C0%7C0%7C639102349945335386%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=XLV1v2vbieMdSN%2F3Kp3v0m3PzEPLY7PWvtmMmTyGjpc%3D&reserved=0">Link</a>.
          </p>
        </div>)}
  </div>);

}

export default Page;